<template>
  <button id="totop" type="button" title="В начало страницы" :class="{ visible: isVisible }" @click="y = 0"></button>
</template>

<script setup>
import { useWindowScroll } from "@vueuse/core";
const { y } = useWindowScroll();
const isVisible = ref(false);
const _t = 200;
watch(y, (n) => {
  if (!isVisible.value && n >= _t) isVisible.value = true;
  else if (isVisible.value && n < _t) isVisible.value = false;
});
</script>